import { IOrganizationNode } from '../models/organization-chart.types';

export const DEFAULT_ORGANIZATION_CHART: IOrganizationNode = {
  label: 'John Doe',
  imageUrl: 'assets/images/profile/john-doe.jpg',
  title: 'CEO',
  currentPhase: 3,
  selected: true,
  level: '',
  score: 2,
  id: 4,
  sk_user: '1',
  children: [
    {
      label: 'Jane Smith',
      imageUrl: 'assets/images/profile/jane-smith.jpg',
      title: 'CTO',
      currentPhase: 1,
      selected: true,
      level: '',
      score: 2,
      id: 1,
      sk_user: '2',
    },
    {
      label: 'Will Brown',
      imageUrl: 'assets/images/profile/jane-smith.jpg',
      title: 'CTO',
      currentPhase: 2,
      selected: true,
      level: '',
      score: 2,
      id: 2,
      sk_user: '3',
    },
    {
      label: 'Sarah Williams',
      imageUrl: 'assets/images/profile/sarah-williams.jpg',
      title: 'CFO',
      currentPhase: 4,
      selected: true,
      level: '',
      score: 2,
      id: 3,
      sk_user: '4',
    },
  ],
};
